import styled, { keyframes } from 'styled-components';
import { TemplateTitleSec } from '../TemplateSection/styles';
import { fadeText, GetStarted } from '../../components/Button/style';
import * as palette from '../../styles/variables';

export const GeneratedDocumentsWrapper = styled.div`
`;
export const GeneratedDocumentsHeadSection = styled.div`
  margin: 110px 100px 70px;
  display: grid;
  grid-template-columns: 57% 43%;
  @media (max-width: 1200px) {
    margin: 110px 70px 70px;
    grid-template-columns: 1fr;
    justify-items: center;
    grid-gap: 2.3rem;
  }
  @media (max-width: 768px) {
    margin: 110px 30px 70px;
  }
`;
export const TemplateTitle = styled(TemplateTitleSec)`
  align-items: flex-start;
  margin: 0;
  .template_title {
    @media only screen and (min-width: 1460px) {
      animation-delay: 0.5s;
      font-size: ${props => (props.isPublishedTemp ? '30px' : '47px')};
    }
  }
`;
export const DocumentMetrics = styled.div`
         border-radius: 21px;
         background: linear-gradient(to right, #531313, #050a84) !important;
         padding: 1rem 1.7rem;
         display: flex;
         flex-flow: column;
         justify-content: center;
         align-items: flex-start;
         max-height: 130px;
         width: fit-content;
         min-width: max-content;
         max-width: 570px;
         @media (max-width: 1200px) {
           align-items: center;
         }
         .metrics-container {
           display: flex;
           justify-content: flex-start;
           align-items: center;
           gap: 11px;
           font-size: 16px;
           width: fit-content;
           .mertics-heading {
             color: white;
             text-align: left;
             font-weight: normal;
             min-width: fit-content;
           }
           .metrics-value {
             color: #ffeb3b;
             font-weight: normal;
             display: flex;
             gap: 5px;
             align-items: center;
             justify-content: flex-start;
             flex-wrap: nowrap;
             min-width: fit-content;
           }
         }
       `;

export const Filters = styled.div`
  display: flex;
  /* justify-content: flex-start; */
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  margin: 50px 100px;
  .environment-container,
  .template-name-container,
  .team-name-container {
    display: flex;
    flex-direction: column;
    min-hight: 70px;
    width: 20%;
    flex-grow: 1;
    font-family: sans-serif;
    label {
      color: rgba(63, 73, 84, 1);
      font-size: 0.875rem;
    }
    .ant-select {
      height: 37px;
      .ant-select-selection {
        height: 37px !important;
      }
    }
  }
  .date-time-picker-container {
    display: flex;
    align-items: flex-end;
    gap: 1rem;
    font-family: sans-serif;
    flex-grow: 1;
    max-width: 730px;
    .dateTimePicker {
      div {
        label {
          align-self: flex-start;
          color: rgba(63, 73, 84, 1);
          font-size: 0.875rem;
        }
        input {
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          height: 40px;
          width: 100%;
        }
      }
    }
  }
  .date-from-picker-container,
  .date-till-picker-container {
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    flex-grow: 1;
    label {
      color: rgba(63, 73, 84, 1);
      font-size: 0.875rem;
    }
    input {
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      height: 40px;
      width: 100%;
    }
  }
  .actions-container {
    font-family: sans-serif;
    display: flex;
    align-self: flex-end;
  }
  .ant-select-selection--multiple .ant-select-selection__placeholder {
    margin-top: -10px;
  }
`;
export const SearchButton = styled(GetStarted)`
  button {
    border-radius: 4px;
  }
`;
export const ClearDataButton = styled(GetStarted)`
         align-self: flex-end;
         button {
           min-width: 143px;
           color: #ffffff;
           background-color: rgba(1, 182, 245, 1);
           box-shadow: 0 0 2px #01b6f5;
           border-radius: 4px;
         }
       `;
export const DocumentTable = styled.div`
         .table_filter-info {
           margin: 30px 100px 0;
           display: flex;
           justify-content: flex-start;
           align-items: center;
           gap: 1.7rem;
           background-color: #fafafa;
           padding: 1rem 0.7rem;
           .selected_documents {
             display: flex;
             align-items: center;
             gap: 0.3rem;
             .title {
             }
             .value {
               color: #00c300;
             }
           }
           .delete_selected-button {
             all: unset;
             text-decoration: underline;
             font-size: 14px;
             color: #01b3ad;
             cursor: pointer;
             margin-right: 1.7rem;
           }
           .search_results {
             display: flex;
             align-items: center;
             gap: 0.3rem;
             title {
             }
             value {
             }
           }
         }
         .ant-table-wrapper {
           margin: 1px 100px 50px;
           .ant-table {
             overflow: hidden;
             overflow-x: auto;
             .ant-table-content {
               min-width: 970px;
             }
           }
           tr {
             th,
             td {
               border-bottom: 2px solid #f1f1f1;
             }
             .selectAllCheckbox {
               width: 107px;
               background-color: #fff;
               border-bottom: 0;
               text-align: center;
             }
             .documentsNameColumn {
               width: 470px;
               @media (max-width: 1080px) {
                 width: 270px;
               }
             }
           }
           .ant-table-thead>tr: first-child > th {
             &.selectAllCheckbox {
               .ant-checkbox-wrapper {
                 width: 37px;
                 display: flex;
                 flex-flow: column;
                 align-items: center;
                 justify-content: flex-start;
                 text-align: center;
               }
             }
           }
           .ant-table-tbody > tr {
             .actionsColumn {
               span {
                 display: flex;
                 flex-flow: row;
                 gap: 0.5rem;
                 .delete-btn {
                   all: unset;
                   display: inline-block;
                   text-decoration: underline;
                   font-size: 14px;
                   color: #1890ff;
                   cursor: pointer;
                   /* width: 47px; */
                   padding-left: 0.5rem;
                   border-left: 3px solid #f3f3f3;
                 }
               }
             }
             .documentsNameColumn {
               text-wrap: wrap;
               @media (max-width: 1080px) {
                 max-width: 370px;
               }
             }
           }
         }
       `;
//Bala
// export const DocumentMetrics = styled.div`
//   margin: 20px 100px !important;
//   display: flex;
//   flex-wrap: wrap;
//   gap: 5%;
//   .storage-container,
//   .document-container {
//     background: linear-gradient(to right, #69006a, #050a84) !important;
//     border-radius: 40px;
//     width: 45%;
//     color: white;
//     padding: 10px;
//     .heading {
//       text-align: center;
//       font-weight: bold;
//       color: white;
//       margin-bottom: 7px;
//     }
//   }
//   .metrics-container {
//     display: flex;
//     justify-content: space-around;
//   }
//   .quota-container,
//   .usage-container,
//   .usage-percentage-container {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     gap: 5px;
//     .metrics-heading {
//       font-size: 14px !important;
//     }
//     .metrics-value {
//       color: #ffeb3b;
//     }
//   }
//   .note {
//     margin: 10px 0 10px 30px;
//     color: #fd3838;
//     font-size: 14px;
//     font-style: italic;
//   }
// `;
